<template>
  <div class="gift">
    <app-header>
      <h1>Stéphanie Lefebvre</h1>
      <h2>Cartes Cadeaux</h2>
    </app-header>
    <div class="content">
      <article>
        <img src="~@/assets/background/left-flower.png" alt="flower" class="flower left">
        <div class="bloc">
          <h4 class="custom">Vous aimeriez faire découvrir un soin énergétique à un proche ou un ami ? Pensez au Chèque Cadeau
            !</h4>
          <h4>     
            *Pour offrir un soin Reiki, LaHoChi, Réflexologie Plantaire ou Shiatsu au choix : chèque cadeau au tarif de 45 euros
          </h4>

          <h4>     
            *Pour offrir un Massage des 5 continents : chèque cadeau au tarif de 70 euros
          </h4>
        </div>
        <img src="~@/assets/background/right-flower.png" alt="flower" class="flower right">
      </article>
    </div>
  </div>
</template>

<script>
  import AppHeader from '@/components/Header'

  export default {
    name: 'Gift',
    components: { AppHeader }
  }
</script>

<style lang="scss" scoped>
  //TODO TEMP
  @import url('https://fonts.googleapis.com/css?family=Cedarville+Cursive|Delius|Sacramento&display=swap');

  .gift {
    display: flex;
    flex-direction: column;
    flex: 1;

    .content {
      position: relative;
      text-align: center;
      background-color: #f1fae7;
      align-items: center;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      @media screen and (max-width: 680px) {
        overflow: auto;
      }

      button {
        outline: none;
        border-radius: 8px;
        padding: 1em;
        border: 2px solid $color-red;
        color: $color-red;
        text-transform: uppercase;
        font-weight: 500;
        cursor: pointer;
        font-size: 1.1em;
        transition: .25s ease all;
        background: none;
        margin-top: 2em;
        width: 100%;
        box-sizing: border-box;

        &:hover {
          box-shadow: inset 0 0 0 2em $color-red;
          color: #fff;
        }
      }

      h4 {
        margin: .5em;
        font-weight: 300;
        font-size: 1.1em;
        font-family: 'Delius', cursive;
        text-align: center;
        padding-bottom: 1em;

        &.custom {
          border-bottom: 2px solid $color-green;
          padding-bottom: 1em;
          margin-bottom: 2em;
          font-weight: 700;
        }
      }

      article {
        @include custom-article();

        p {
          text-align: center;
        }

        img {
          position: absolute;
          z-index: 0;
          opacity: .5;

          &.left {
            bottom: -7vw;
            left: 4vw;
          }

          &.right {
            top: 0;
            right: 4vw;
          }
        }
      }
    }
  }
</style>
